import { get, getRawValue } from '../../utils/get';
import { getRawImageObject } from '../../adapters/get-raw-image-object';
import { getItemsSdStatus } from '../utils';
import { SD_STATUS } from '../../consts';
export var getStructuredData = function (IDs, item, collectionItems) {
    var _a;
    if (!IDs) {
        return {};
    }
    var imagesData = collectionItems.map(function (collectionItem) {
        return {
            url: get(collectionItem, 'project.coverImage.imageInfo.url'),
            width: get(collectionItem, 'project.coverImage.imageInfo.width'),
            height: get(collectionItem, 'project.coverImage.imageInfo.height'),
            name: get(collectionItem, 'project.coverImage.imageInfo.altText'),
        };
    });
    var coverImage = getRawValue(item, 'collection.coverImage');
    if (coverImage) {
        imagesData.push({
            url: get(coverImage, 'imageInfo.url'),
            width: get(coverImage, 'imageInfo.width'),
            height: get(coverImage, 'imageInfo.height'),
            name: get(coverImage, 'imageInfo.altText'),
        });
    }
    var _b = getRawImageObject('images', imagesData, false).images, images = _b === void 0 ? '' : _b;
    var imagesSdStatus = getItemsSdStatus(imagesData, images);
    return _a = {},
        _a[IDs.SD_JSON_IMAGES] = images,
        _a[IDs.IMAGES_SD_STATUS] = imagesSdStatus,
        _a[IDs.DISABLE_IMAGES_SCHEMA] = imagesSdStatus !== SD_STATUS.ENABLED,
        _a;
};
